import Alert from 'react-bootstrap/Alert';
import Button from 'react-bootstrap/Button';
import Card from 'react-bootstrap/Card';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import ListGroup from 'react-bootstrap/ListGroup';
import Row from 'react-bootstrap/Row';
import FavouritesPanel from "./FavouritesPanel";

function SearchPage({ error, favourites, plateInput, onOpenVehicle, onPlateInputChange, onRemoveFavourite, onSearch }) {
  return (
    <main>
      <Container className="py-5">
        <Row className="justify-content-center">
          <Col xs={12} lg={8}>
            <Card className="shadow-sm">
              <Card.Body className="p-4 p-md-5">
                <h1 className="h2 mb-3">Rekkari v3</h1>
                <Form onSubmit={onSearch}>
                  <Row className="g-3 align-items-end">
                    <Col xs={12} md>
                      <Form.Group controlId="plate-input">
                        <Form.Control
                          type="text"
                          inputMode="text"
                          autoComplete="off"
                          placeholder="ABC-123"
                          value={plateInput}
                          onChange={(event) => onPlateInputChange(event.target.value)}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md="auto">
                      <Button className="w-100" variant="primary" type="submit">
                        Search
                      </Button>
                    </Col>
                  </Row>
                </Form>

                {error ? (
                  <Alert className="mt-4 mb-0" variant="danger">
                    {error}
                  </Alert>
                ) : null}
              </Card.Body>
            </Card>

            <FavouritesPanel favourites={favourites} onOpenVehicle={onOpenVehicle} onRemoveFavourite={onRemoveFavourite} />
          </Col>
        </Row>
      </Container>
    </main>
  );
}

export default SearchPage;
